<template>
  <div class="home min-container">
    <div class="container">
      <div class="left">
        <p class="p1">
          {{ $t('common.p106') }}
        </p>
        <p class="p2">
          {{ $t('common.p107') }}
        </p>
        <div
          class="button1"
          @click="toHome()"
        >
          <p>{{ $t('common.p108') }}</p>
        </div>
      </div>
      <!-- 提前加载 -->
      <img
        src="/official/static/img/404/light_02.jpg"
        alt=""
        style="display:none;"
      >
      <img
        src="/official/static/img/404/light_03.jpg"
        alt=""
        style="display:none;"
      >
      <img
        src="/official/static/img/404/light_04.jpg"
        alt=""
        style="display:none;"
      >
      <div
        v-if="showAnimal"
        class="right"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      showAnimal: false
    };
  },
  mounted() {
    document
      .querySelector("#app")
      .scrollIntoView({ block: "start", behavior: "smooth" });
    setTimeout(() => {
      this.showAnimal = true
    }, 1000);
  },
  methods: {
    toHome() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.home {
  position: relative;
  width: 100%;
  height: 470px;
  background-image: url(/official/static/img/404/light_01.jpg);
  background-repeat: no-repeat;
  background-position: center center;
  color: #323232;
  overflow: hidden;
  .container {
    position: relative;
    
    height: 100%;
  }
  .left {
    position: relative;
    z-index: 2;
    width: 550px;
    padding-top: 60px;
    .p1 {
      font-size: 66px;
      line-height: 76px;
      font-weight: bold;
      color: #242424;
    }
    .p2 {
      font-size: 24px;
      margin-bottom: 30px;
      color: #242424;
    }
    .button1 {
      width: 310px;
      height: 40px;
      background-color: #1f9d56;
      text-align: center;
      cursor: pointer;
      margin-bottom: 6px;
      p {
        line-height: 40px;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
  @keyframes run {
      0% {
        
      }
      3% {
        background-image: url(/official/static/img/404/light_02.jpg);
      }
      6% {
        background-image: none;
      }
      9% {
        background-image: url(/official/static/img/404/light_02.jpg);
      }
      12% {
        background-image: none;
      }
      30% {
        background-image: url(/official/static/img/404/light_03.jpg);
        opacity: 0.3;
      }
      35% {
        background-image: url(/official/static/img/404/light_03.jpg);
        opacity: 0.4;
      }
      40% {
        background-image: url(/official/static/img/404/light_03.jpg);
        opacity: 0.5;
      }
      50% {
        background-image: url(/official/static/img/404/light_03.jpg);
        opacity: 1;
      }
      65% {
        background-image: none;
      }
      70% {
        background-image: url(/official/static/img/404/light_04.jpg);
      }
      75% {
        background-image: none;
      }
      80% {
        background-image: url(/official/static/img/404/light_03.jpg);
      }
      85% {
        background-image: none;
      }
      90% {
        background-image: url(/official/static/img/404/light_04.jpg);
      }
      96% {
        background-image: url(/official/static/img/404/light_04.jpg);
      }
      100% {
        background-image: url(/official/static/img/404/light_02.jpg);
      }
    }
  .right {
    position: absolute;
    z-index: 1;
    width: 1119px;
    height: 470px;
    top: 0px;
    right: -177px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // animation: fadeIn;
    // animation-duration: 2s;
    animation: run 3s linear;
  }
}
</style>
